import React from 'react';
import { setInfoMessage, setDurationMessage } from './utils';
import Typography from '@material-ui/core/Typography';
import { Icon } from '@material-ui/core';
import AlertIcon from '../AlertIcon';
import '../../styles/chart-styles.css';
import CustomTooltip from '../CustomTooltip';

export default function TransferTooltip({ payload, active }) {
    if (active && payload !== null) {
        const time = payload[0].payload;
        const alertIcon = () => {
            if(time.transmitFailed) {
                return <Icon>
                    <AlertIcon critical={true} color="secondary" />
                </Icon>
            } else return "";
        }
        return (
            <CustomTooltip payload={payload} active={active}>
                <div className="tooltip-warning-container">
                    {alertIcon()}
                    <Typography component="p" >{setInfoMessage(time)}</Typography>
                </div>
                <Typography component="p" >Sent: {time.name}</Typography>
                <Typography component="p" >{setDurationMessage(time)}</Typography>
            </CustomTooltip>
        );
    } else return null;
}


// WEBPACK FOOTER //
// ./src/components/TransferTooltip/TransferTooltip.js